import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ComicCard from '@/components/base/ComicCard';
import { allCategories, allComics, comicsByCategory } from '@/mocks/comics';

const jsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: '首页', item: 'http://emenculture.com/' },
        { '@type': 'ListItem', position: 2, name: '全部分类', item: 'http://emenculture.com/category' },
      ],
    },
    {
      '@type': 'CollectionPage',
      name: '韩漫分类 - 全部分类',
      description: '浏览韩漫网全部分类，包括恋爱、奇幻、动作、悬疑、搞笑、重生、职场、恐怖等类型的高清韩国漫画',
      url: 'http://emenculture.com/category',
      isPartOf: { '@id': 'http://emenculture.com/#website' },
    },
  ],
};

export default function Category() {
  const [activeCategory, setActiveCategory] = useState<string>('all');
  const [displayComics, setDisplayComics] = useState(allComics);

  useEffect(() => {
    if (activeCategory === 'all') {
      setDisplayComics(allComics);
    } else {
      const ids = comicsByCategory[activeCategory] || [];
      setDisplayComics(allComics.filter((c) => ids.includes(c.id)));
    }
  }, [activeCategory]);

  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);
    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <section className="relative pt-28 pb-16 md:pt-36 md:pb-20">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=A%20soft%20artistic%20abstract%20background%20with%20warm%20cream%20and%20peach%20gradient%2C%20subtle%20flowing%20curves%2C%20delicate%20paper%20texture%2C%20Korean%20manhwa%20library%20aesthetic%2C%20clean%20minimal%20composition%2C%20dreamy%20and%20elegant%20atmosphere%2C%20soft%20light%20tones%20with%20subtle%20pink%20and%20gold%20accents%2C%20artistic%20illustration%20style%2C%20wide%20composition&width=1920&height=600&seq=category-hero-bg-01&orientation=landscape"
              alt="韩漫网分类"
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-black/10 via-black/5 to-background-50"></div>
          </div>
          <div className="relative z-10 max-w-[1440px] mx-auto px-6 md:px-10 text-center">
            <h1 className="font-heading text-4xl md:text-5xl lg:text-6xl font-black text-foreground-900">
              全部分类
            </h1>
            <p className="mt-3 text-sm md:text-base text-foreground-600">
              探索韩漫网全部漫画类型，找到属于你的完美故事
            </p>
          </div>
        </section>

        <section className="pb-16">
          <div className="max-w-[1440px] mx-auto px-6 md:px-10">
            <div className="flex flex-wrap items-center gap-2 mb-10">
              <button
                onClick={() => setActiveCategory('all')}
                className={`px-5 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  activeCategory === 'all'
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                全部
              </button>
              {allCategories.map((cat) => (
                <button
                  key={cat.id}
                  onClick={() => setActiveCategory(cat.id)}
                  className={`inline-flex items-center gap-1.5 px-5 py-2.5 rounded-full text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                    activeCategory === cat.id
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-background-100 text-foreground-600 hover:text-foreground-900 hover:bg-background-200'
                  }`}
                >
                  <i className={`${cat.icon} text-sm`}></i>
                  {cat.name}
                </button>
              ))}
            </div>

            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
              {displayComics.map((comic) => (
                <ComicCard key={comic.id} {...comic} />
              ))}
            </div>

            {displayComics.length === 0 && (
              <div className="text-center py-20">
                <p className="text-foreground-500">该分类暂无漫画，敬请期待~</p>
              </div>
            )}
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}